function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import classnames from "classnames";
import { shouldHaveEnhancedProductsInHeaderTest, shouldShowSuccessStoriesInHeaderTest } from "services/ab-tests/acquisition-ab-test-service";
import { SIGNUP_BUTTON_TYPE } from "segments/desktop/core-components/button/button-consts";
import { isExistingUserInHeaderTest, getSignupLink } from "services/monday-platform/existing-accounts-service";
import { withAbTests } from "contexts/ab-tests-context";
import { CUSTOMERS_MENU_ID, PLATFORM_MENU_ID, RESOURCES_MENU_ID, SOLUTIONS_MENU_ID, StructuredHeaderMenuComponentMapping, StructuredHeaderMenuMapping, TEAMS_MENU_ID } from "segments/desktop/header/layouts/base-header/base-header-service";
import HeaderConstants from "segments/desktop/header/layouts/base-header/constants.js";
import LinkItemWithMenuComponent from "segments/desktop/header/layouts/base-header/base-header-desktop/link-item-with-menu/link-item-with-menu-component.js";
import LanguagePickerComponent from "components/core/language-picker/language-picker-component";
import { DIALOG_DIRECTIONS } from "components/core/language-picker/language-picker-service";
import LinkItemComponent from "segments/desktop/header/layouts/base-header/base-header-desktop/link-item/link-item-component";
import { CONTACT_US_FROM_HEADER_PAGE_LINK, LOGIN_PAGE_LINK, PRICING_PAGE_LINK } from "constants/links";
import RegularButton from "segments/desktop/core-components/button/regular-button/regular-button";
import { WORK_OS_IRIS_COLOR_NAME, WHITE_COLOR_NAME } from "styles/color-consts";
import { SM } from "constants/sizes";
import Button from "segments/desktop/core-components/button/button";
import { withGenericConfig } from "contexts/generic-config-context";
import { shouldGetTypeformExperience } from "services/typeform/typeform-service";
import { useContactSalesTypeform } from "client/services/hooks/use-contact-cales-typeform";
import { fireGtmEvent } from "client/services/gtm-service/gtm-service";
import DataLayerEventTypes from "constants/data-layer-event-types";
import PictureComponent from "/components/core/picture/picture-component";
import { HEADER_SWITCHER_OPENED, HEADER_LINK_CLICKED, HEADER_SWITCHER_LOGO_HOVERED } from "constants/bigbrain-event-types";
import HeaderMenus from "../header-menu/index.js";
import { StyledStructuredHeader } from "./structured-header.scss";
import { trackEvent } from "/services/bigbrain-service";
import { PRODUCTS_SWITCHER_LOGO, PRODUCTS_SWITCHER_LOGO_DARK } from "./const";
const StructuredHeader = (props)=>{
    const { showMenu, showButton, buttonConfig, hideLanguagePicker, shouldShowMainPricingLink, isSecondaryMenuNeeded, renderUnifiedLinks, hideLogin, abTests, openedMenuId, openLinkMenu, closeLinkMenu, isExistingAccountHeader, isTypeformDisabled, translate, persistantCookies, pageProductId, showSuccessStoriesInHeader, shouldHaveEnhancedProducts, setShowproductsSwithcer, showproductsSwithcer, isInContactSalesNoHeaderTest, isDynamicColor, removeContactSalesButton } = props;
    const openSolutionsMenu = ()=>openLinkMenu(SOLUTIONS_MENU_ID);
    const openTeamsMenu = ()=>openLinkMenu(TEAMS_MENU_ID);
    const openPlatformMenu = ()=>openLinkMenu(PLATFORM_MENU_ID);
    const openCustomersMenu = ()=>openLinkMenu(CUSTOMERS_MENU_ID);
    const openResourcesMenu = ()=>openLinkMenu(RESOURCES_MENU_ID);
    const isMenuOpen = (menuId)=>{
        return openedMenuId === menuId;
    };
    const shouldGetProductsSwitcherExperience = !isExistingAccountHeader && !isExistingUserInHeaderTest(persistantCookies) && showMenu;
    const renderSubmenuWithTransitionIfNeeded = (menuId)=>{
        // always render transition - menu rendered only if open
        const isMenuOpen = openedMenuId === menuId;
        return /*#__PURE__*/ _jsx("div", {
            children: isMenuOpen && renderMainHeaderPopup(menuId)
        });
    };
    const renderMainHeaderPopup = (menuId)=>{
        const enhancedProducts = menuId === SOLUTIONS_MENU_ID && (shouldHaveEnhancedProducts || shouldHaveEnhancedProductsInHeaderTest(abTests, true));
        const headerMenuItems = StructuredHeaderMenuMapping[menuId];
        const MenuComponent = HeaderMenus[StructuredHeaderMenuComponentMapping[menuId]];
        return /*#__PURE__*/ _jsx("div", {
            className: classnames(HeaderConstants.HEADER_MENU_COMPONENT_WRAPPER_CLASS_NAME, {
                "enhanced-products": enhancedProducts
            }),
            children: /*#__PURE__*/ _jsx("nav", {
                "aria-label": "main submenu",
                className: "menu-component-wrapper",
                children: MenuComponent && /*#__PURE__*/ _jsx(MenuComponent, {
                    menuItems: headerMenuItems,
                    menuId: menuId,
                    enhancedProducts: enhancedProducts
                })
            })
        }, menuId);
    };
    const showSuccessStories = showSuccessStoriesInHeader || shouldShowSuccessStoriesInHeaderTest(abTests, true);
    const renderBaseHeaderLeftLinks = ()=>{
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: classnames("link-item-with-menu-component-wrapper", {
                        "is-open": isMenuOpen(SOLUTIONS_MENU_ID)
                    }),
                    role: "listitem",
                    children: /*#__PURE__*/ _jsx(LinkItemWithMenuComponent, {
                        title: "header.products",
                        openMenu: openSolutionsMenu,
                        closeMenu: closeLinkMenu,
                        isOpen: isMenuOpen(SOLUTIONS_MENU_ID)
                    })
                }),
                renderSubmenuWithTransitionIfNeeded(SOLUTIONS_MENU_ID),
                /*#__PURE__*/ _jsx("div", {
                    className: classnames("link-item-with-menu-component-wrapper", {
                        "is-open": isMenuOpen(TEAMS_MENU_ID)
                    }),
                    role: "listitem",
                    children: /*#__PURE__*/ _jsx(LinkItemWithMenuComponent, {
                        title: "header.teams",
                        openMenu: openTeamsMenu,
                        closeMenu: closeLinkMenu,
                        isOpen: isMenuOpen(TEAMS_MENU_ID)
                    })
                }),
                renderSubmenuWithTransitionIfNeeded(TEAMS_MENU_ID),
                /*#__PURE__*/ _jsx("div", {
                    className: classnames("link-item-with-menu-component-wrapper", {
                        "is-open": isMenuOpen(PLATFORM_MENU_ID)
                    }),
                    role: "listitem",
                    children: /*#__PURE__*/ _jsx(LinkItemWithMenuComponent, {
                        title: "header.platform",
                        openMenu: openPlatformMenu,
                        closeMenu: closeLinkMenu,
                        isOpen: isMenuOpen(PLATFORM_MENU_ID)
                    })
                }),
                renderSubmenuWithTransitionIfNeeded(PLATFORM_MENU_ID),
                showSuccessStories && /*#__PURE__*/ _jsx("div", {
                    className: classnames("link-item-with-menu-component-wrapper", {
                        "is-open": isMenuOpen(CUSTOMERS_MENU_ID)
                    }),
                    role: "listitem",
                    children: /*#__PURE__*/ _jsx(LinkItemWithMenuComponent, {
                        title: "header.successStories",
                        openMenu: openCustomersMenu,
                        closeMenu: closeLinkMenu,
                        isOpen: isMenuOpen(CUSTOMERS_MENU_ID)
                    })
                }),
                showSuccessStories && renderSubmenuWithTransitionIfNeeded(CUSTOMERS_MENU_ID),
                /*#__PURE__*/ _jsx("div", {
                    className: classnames("link-item-with-menu-component-wrapper", {
                        "is-open": isMenuOpen(RESOURCES_MENU_ID)
                    }),
                    role: "listitem",
                    children: /*#__PURE__*/ _jsx(LinkItemWithMenuComponent, {
                        title: "header.resources",
                        openMenu: openResourcesMenu,
                        closeMenu: closeLinkMenu,
                        isOpen: isMenuOpen(RESOURCES_MENU_ID)
                    })
                }),
                renderSubmenuWithTransitionIfNeeded(RESOURCES_MENU_ID)
            ]
        });
    };
    const fireEvent = ()=>{
        fireGtmEvent(DataLayerEventTypes.SIGNUP_CLICKED, {
            click_text: translate("existingAccount.createAccountCta"),
            click_location: "header"
        });
    };
    const prominantContactSalesClicked = ()=>{
        trackEvent(HEADER_LINK_CLICKED, {
            info2: "header.contactSales"
        });
    };
    const buildHeaderStructure = ()=>{
        // init header according to its props
        const headerStructure = {
            leftLinks: {
                isVisible: showMenu
            },
            languagePicker: {
                isVisible: !showMenu && showButton && !hideLanguagePicker
            },
            pricing: {
                isVisible: showMenu && shouldShowMainPricingLink()
            },
            login: {
                isVisible: showMenu && !hideLogin
            },
            contactSales: {
                isVisible: showButton && (buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.buttonType) === SIGNUP_BUTTON_TYPE && !removeContactSalesButton && !isInContactSalesNoHeaderTest
            },
            button: {
                isVisible: showButton
            }
        };
        if ((buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.buttonType) === SIGNUP_BUTTON_TYPE && showButton && (isExistingAccountHeader || isExistingUserInHeaderTest(persistantCookies))) {
            headerStructure.login.isVisible = false;
            headerStructure.button.extraProps = {
                forceGoToMyAccount: true
            };
        }
        return headerStructure;
    };
    const showSwitcher = ()=>{
        if (!showproductsSwithcer) {
            trackEvent(HEADER_SWITCHER_OPENED);
        }
        setShowproductsSwithcer(!showproductsSwithcer);
    };
    const { leftLinks, languagePicker, pricing, contactSales, login, button } = buildHeaderStructure();
    return /*#__PURE__*/ _jsxs(StyledStructuredHeader, {
        "aria-label": "Main",
        className: classnames("base-header-desktop-content"),
        children: [
            leftLinks.isVisible && /*#__PURE__*/ _jsxs("div", {
                className: "left-side-header-links",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "absolute-main-links",
                        role: "list",
                        children: renderBaseHeaderLeftLinks()
                    }),
                    isSecondaryMenuNeeded && /*#__PURE__*/ _jsx("div", {
                        className: "absolute-unified-links",
                        children: renderUnifiedLinks()
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "right-side-header-links",
                role: "list",
                children: [
                    languagePicker.isVisible && /*#__PURE__*/ _jsx("div", {
                        className: classnames("link-item-component-wrapper", "header-language-picker"),
                        children: /*#__PURE__*/ _jsx(LanguagePickerComponent, {
                            dialogDirection: DIALOG_DIRECTIONS.ALIGN_BOTTOM,
                            showLabel: false,
                            showMainLanguagesOnly: true
                        })
                    }),
                    pricing.isVisible && /*#__PURE__*/ _jsx("div", {
                        className: "link-item-component-wrapper",
                        role: "listitem",
                        children: /*#__PURE__*/ _jsx(LinkItemComponent, {
                            title: "header.pricing",
                            url: PRICING_PAGE_LINK
                        })
                    }),
                    login.isVisible && /*#__PURE__*/ _jsx("div", {
                        className: "link-item-component-wrapper",
                        role: "listitem",
                        children: /*#__PURE__*/ _jsx(LinkItemComponent, {
                            title: "header.logIn",
                            url: LOGIN_PAGE_LINK
                        })
                    })
                ]
            }),
            contactSales.isVisible && /*#__PURE__*/ _jsx("div", {
                className: "header-prominant-contact-sales-button-wrapper",
                children: /*#__PURE__*/ _jsx(RegularButton, {
                    buttonText: translate("header.contactSales"),
                    color: isDynamicColor ? WHITE_COLOR_NAME : WORK_OS_IRIS_COLOR_NAME,
                    outline: true,
                    url: CONTACT_US_FROM_HEADER_PAGE_LINK,
                    isWithArrow: false,
                    buttonSize: SM,
                    onClick: prominantContactSalesClicked,
                    extraEventData: {
                        englishText: "Contact sales"
                    }
                })
            }),
            button.isVisible && /*#__PURE__*/ _jsx("div", {
                className: "header-button-wrapper",
                children: /*#__PURE__*/ _jsx(Button, _object_spread(_object_spread_props(_object_spread({}, buttonConfig), {
                    parentSegment: HeaderConstants.DESKTOP_HEADER_SEGMENT_NAME
                }), button.extraProps))
            }),
            shouldGetProductsSwitcherExperience && /*#__PURE__*/ _jsx("div", {
                className: classnames("products-switcher-open-button", {
                    "show-switcher": showproductsSwithcer
                }),
                onClick: ()=>showSwitcher(),
                onMouseEnter: ()=>trackEvent(HEADER_SWITCHER_LOGO_HOVERED),
                children: /*#__PURE__*/ _jsx(PictureComponent, {
                    src: isDynamicColor && !showproductsSwithcer ? PRODUCTS_SWITCHER_LOGO_DARK : PRODUCTS_SWITCHER_LOGO
                })
            })
        ]
    });
};
export default withGenericConfig(withAbTests(StructuredHeader));
